import React from 'react'
import {
  Upload,
  Checkbox,
  ColorPicker,
  SingleDatePicker,
  TimePicker,
  Input,
  Select,
} from 'components/Form'
import { getMessage } from 'lib/translator'
import './style.scss'

const TimerConfig = ({ generateStateMappers }) => {
  return (
    <>
      <div className="swimlane-dressup__timer-start">
        <SingleDatePicker
          required
          enableToday
          label={getMessage('apphome.startDate')}
          placeholder={getMessage('apphome.startDate')}
          {...generateStateMappers({
            stateKeys: [
              'mConfig',
              'default',
              'style',
              'countdownTimer',
              'startDate',
            ],
            loseEmphasisOnFill: true,
          })}
        />
        <TimePicker
          required
          label={getMessage('apphome.startTime')}
          placeholder={getMessage('apphome.startTime')}
          {...generateStateMappers({
            stateKeys: [
              'mConfig',
              'default',
              'style',
              'countdownTimer',
              'startTime',
            ],
            loseEmphasisOnFill: true,
          })}
        />
      </div>
      <div className="swimlane-dressup__timer-duration">
        <Input
          required
          type="number"
          min={1}
          label={getMessage('app.layout.swimlane-dressup.timer.restart')}
          name="timer-duration"
          placeholder={getMessage(
            'app.layout.swimlane-dressup.timer.duration.placeholder'
          )}
          {...generateStateMappers({
            stateKeys: [
              'mConfig',
              'default',
              'style',
              'countdownTimer',
              'duration',
            ],
            loseEmphasisOnFill: true,
          })}
        />
        <div className="select-wrapper">
          <Select
            required
            name="timer-unit"
            className="timer-unit"
            placeholder={getMessage(
              'app.layout.swimlane-dressup.timer.duration-unit.placeholder'
            )}
            options={[
              {
                text: getMessage(
                  'app.layout.swimlane-dressup.timer.duration-unit.minute'
                ),
                value: 'minute',
              },
              {
                text: getMessage(
                  'app.layout.swimlane-dressup.timer.duration-unit.hour'
                ),
                value: 'hour',
              },
            ]}
            {...generateStateMappers({
              stateKeys: [
                'mConfig',
                'default',
                'style',
                'countdownTimer',
                'durationUnit',
              ],
              loseEmphasisOnFill: true,
            })}
          />
        </div>
      </div>
    </>
  )
}

const SwimlaneDressup = ({
  children,
  generateStateMappers,
  enableTimerConfiguration,
  handleTimerConfiguration,
}) => {
  return (
    <>
      <div className="swimlane-dressup">
        <h3>{getMessage('app.layout.header.swimlane-dressup')}</h3>
        <Upload
          label={getMessage('app.layout.swimlane-dressup.header.image')}
          placeholder={getMessage('apphome.upload.image.placeholder')}
          {...generateStateMappers({
            stateKeys: ['mConfig', 'default', 'style', 'header', 'imageUrl'],
            loseEmphasisOnFill: true,
          })}
          required
        />
        <div className="swimlane-dressup__colorpicker-preview">
          <div className="swimlane-dressup__colorpicker">
            <div className="swimlane-dressup__colorpicker-group">
              <ColorPicker
                required
                label={getMessage(
                  'app.layout.swimlane-dressup.background.color'
                )}
                {...generateStateMappers({
                  stateKeys: [
                    'mConfig',
                    'default',
                    'style',
                    'background',
                    'color',
                  ],
                  loseEmphasisOnFill: true,
                })}
              />
              <ColorPicker
                required
                label={getMessage('app.layout.swimlane-dressup.cta.text.color')}
                {...generateStateMappers({
                  stateKeys: [
                    'mConfig',
                    'default',
                    'style',
                    'header',
                    'ctaTextColor',
                  ],
                  loseEmphasisOnFill: true,
                })}
              />
              <Checkbox
                name="enable-timer"
                inlineLabel={getMessage(
                  'app.layout.swimlane-dressup.timer.enable'
                )}
                value={enableTimerConfiguration}
                onChange={(event) => {
                  handleTimerConfiguration(event)
                }}
              />
            </div>
            {enableTimerConfiguration && (
              <div className="timer-colorpicker">
                <h3>{getMessage('app.layout.header.timer.configuration')}</h3>
                <ColorPicker
                  required
                  label={getMessage(
                    'app.layout.swimlane-dressup.timer.background.color'
                  )}
                  {...generateStateMappers({
                    stateKeys: [
                      'mConfig',
                      'default',
                      'style',
                      'countdownTimer',
                      'bgColor',
                    ],
                    loseEmphasisOnFill: true,
                  })}
                />
                <ColorPicker
                  required
                  label={getMessage(
                    'app.layout.swimlane-dressup.timer.text.color'
                  )}
                  {...generateStateMappers({
                    stateKeys: [
                      'mConfig',
                      'default',
                      'style',
                      'countdownTimer',
                      'textColor',
                    ],
                    loseEmphasisOnFill: true,
                  })}
                />
              </div>
            )}
          </div>
          <div className="swimlane-dressup__preview">{children}</div>
        </div>
      </div>
      {enableTimerConfiguration && (
        <TimerConfig generateStateMappers={generateStateMappers} />
      )}
    </>
  )
}

export default SwimlaneDressup
